import {BaseApiService} from "../../../infrastructure/domain-services/base-api-service";
import {BaseUtilsService} from "../../../infrastructure/domain-services/base-utils-service";
import {EntitiesFactory} from "./entities.factory";

export class EntitiesApi extends BaseApiService {
  static injectables = [...BaseUtilsService.injectables, EntitiesFactory];
}
